



















import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class MenuDrilldownMenuListItem extends Vue {
  @Prop()
  title: string;

  @Prop({default: true})
  hasClose: boolean;
}
